import { Link } from 'react-router-dom';
import Button, { ButtonProps } from '../controls/Button';

export default function LinkButton({
  children,
  external = true,
  to,
  href,
  ...rest
}: LinkButtonProps) {
  if (to) {
    const props = { ...rest, to };
    return (
      <Button component={Link} {...props}>
        {children}
      </Button>
    );
  }

  if (href) {
    const attrs = {
      ...(external ? { target: '_blank', rel: 'noreferrer' } : {}),
      ...rest,
    };

    return (
      <Button component="a" href={href} {...attrs}>
        {children}
      </Button>
    );
  }

  return <Button {...rest}>{children}</Button>;
}

export interface LinkButtonProps extends ButtonProps {
  external?: boolean;
  href?: string;
  to?: string;
}
